import { Navigate } from 'react-router-dom'
import { APP_ROUTES } from 'shared/constants/routes'
import { SessionStorageKey } from 'shared/constants/sessionStorage'
import { useSearchParams } from 'shared/hooks/useSearchParams'
import { validateRedirectUrl } from 'shared/utils/validateRedirectUrl'

import { GuestRouteProps } from './GuestRoute.types'

export const GuestRoute: React.FC<GuestRouteProps> = ({
  children,
  isLoggedIn
}) => {
  const [{ redirect_url }] = useSearchParams<{
    redirect_url?: string
  }>()
  const hasCustomRedirect = sessionStorage.getItem(
    SessionStorageKey.HAS_CUSTOM_LOGIN_REDIRECT
  )
  if (isLoggedIn && !hasCustomRedirect) {
    const destination = redirect_url
      ? validateRedirectUrl(redirect_url, APP_ROUTES.desktop.path)
      : APP_ROUTES.desktop.path
    return <Navigate to={destination} replace />
  }

  return <>{children}</>
}
